import { Icon, IconProps } from '@chakra-ui/react'

export default function TagIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#868E96'}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.61685 12.317C6.39182 12.5424 6.08644 12.6691 5.76794 12.6693C5.44944 12.6694 5.14393 12.543 4.91865 12.3179L2.34988 9.75046C2.12461 9.5253 1.99805 9.21986 1.99805 8.90136C1.99805 8.58287 2.12461 8.27743 2.34988 8.05227L6.68168 3.72247C6.93182 3.47246 7.27101 3.33203 7.62467 3.33203H10.0014C10.7381 3.33203 11.3353 3.92923 11.3353 4.66592V7.03923C11.3353 7.39263 11.195 7.7316 10.9453 7.98169L6.61685 12.317Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.003 5.33301V7.86566C14.003 8.21943 13.8625 8.55871 13.6123 8.80886L9.83594 12.5853"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
